import React, { useState, useContext } from "react";
import "./feriado-modal.scss";
import { Formik } from "formik";
import Lottie from "react-lottie";
import MainContext from "../../../../Contexts/MainContext";
import { updateFeriadoById, deleteFeriadoById } from "../../../../Services/ApiCalls";
import { showToast } from "../../../../Functions";
import { customConfirmAlert as confirmAlert } from '../../../../Functions';
import { BsTrash } from "react-icons/bs";

const LOADING = require("../../../../Assets/animations/loading.json");
const SUCCESS = require("../../../../Assets/animations/success.json");
const ERROR = require("../../../../Assets/animations/error.json");

interface SelectedFeriadoProps {
    data: any;
}

const SelectedFeriado: React.FC<SelectedFeriadoProps> = ({ data }) => {
    const { token, sethasCloseEditModal, removehasCloseEditModal, setOpenMoreInfo } = useContext(MainContext);

    const [isSubmiting, setIsSubmiting] = useState(false);
    const [updateSuccess, setupdateSuccess] = useState(false);
    const [updateError, setUpdateError] = useState(false);

    const askIfDelete = () => {
        confirmAlert({
            title: "Atenção: ação irreversível",
            message: `Tem certeza que deseja excluir o feriado ${data.nome}?`,
            buttons: [
                {
                    label: "Sim, excluir",
                    onClick: async () => {
                        setIsSubmiting(true);
                        const responseRemove = await deleteFeriadoById(token, data.id);
                        if (responseRemove?.status === 200) {
                            setupdateSuccess(true);
                            window.setTimeout(() => {
                                showToast("SUCCESS", `Feriado ${data.nome} excluído!`, {});
                                sethasCloseEditModal(true);
                                removehasCloseEditModal("closedModal");
                                setOpenMoreInfo(false);
                            }, 2000);
                        } else {
                            setUpdateError(true);
                            showToast("ERROR", "Algo deu errado 😣", {});
                            setIsSubmiting(false);
                        }
                    },
                },
                { label: "Cancelar", onClick: () => {} },
            ],
        });
    };

    return (
        <div className="selected__wrapper feriado-modal-wrapper">
            {!isSubmiting ? (
                <Formik
                    initialValues={{ nome: data.nome, data: data.data, tipo: data.tipo, aliquota: data.aliquota, recorrente: data.recorrente || false }}
                    onSubmit={async (values) => {
                        setIsSubmiting(true);
                        const payload = {
                            id: data.id,
                            nome: values.nome,
                            data: values.data,
                            tipo: values.tipo,
                            aliquota: Number(values.aliquota),
                            recorrente: values.recorrente
                        };

                        const responseSubmit = await updateFeriadoById(token, data.id, payload);

                        if (responseSubmit?.status === 200) {
                            setupdateSuccess(true);
                            showToast("SUCCESS", "Feriado atualizado com sucesso!", {});
                            window.setTimeout(() => {
                                sethasCloseEditModal(true);
                                removehasCloseEditModal("closedModal");
                                setOpenMoreInfo(false);
                            }, 2000);
                        } else {
                            setUpdateError(true);
                            showToast("ERROR", "Erro ao atualizar feriado", {});
                            setIsSubmiting(false);
                        }
                    }}
                    validate={(values) => {
                        const errors: any = {};
                        if (!values.nome) errors.nome = "Insira o nome do feriado";
                        if (!values.data) errors.data = "Selecione a data";
                        if (values.aliquota === undefined || values.aliquota === null || values.aliquota < 0) errors.aliquota = "Alíquota inválida";
                        return errors;
                    }}
                >
                    {({ values, handleChange, handleSubmit, errors }) => (
                        <form onSubmit={handleSubmit} className="feriado-form">
                            <div className="feriado-modal-header">
                                <h2>Editar Feriado</h2>
                            </div>

                            <div className="form-grid-row">
                                <div className="form-cell grow-2">
                                    <label>Nome do Feriado</label>
                                    <input 
                                        type="text" 
                                        value={values.nome}
                                        className={errors.nome ? "hasError" : ""}
                                        onChange={handleChange("nome")}
                                    />
                                </div>
                                <div className="form-cell grow-1">
                                    <label>Data</label>
                                    <input 
                                        type="date" 
                                        value={values.data}
                                        className={errors.data ? "hasError" : ""}
                                        onChange={handleChange("data")}
                                    />
                                </div>
                            </div>

                            <div className="form-grid-row">
                                <div className="form-cell grow-1">
                                    <label>Tipo</label>
                                    <select value={values.tipo} onChange={handleChange("tipo")}>
                                        <option value="Nacional">Nacional</option>
                                        <option value="Municipal">Municipal</option>
                                        <option value="Facultativo">Facultativo</option>
                                    </select>
                                </div>
                                <div className="form-cell grow-1">
                                    <label>Alíquota de Acréscimo (%)</label>
                                    <div className="aliquota-input-wrapper">
                                        <input 
                                            type="number" 
                                            value={values.aliquota}
                                            className={errors.aliquota ? "hasError" : ""}
                                            onChange={handleChange("aliquota")}
                                        />
                                        <span className="percent-sign">%</span>
                                    </div>
                                </div>
                            </div>

                            <div className="form-grid-row">
                                <div className="form-cell grow-1">
                                    <label>Feriado Recorrente (Anual)?</label>
                                    <div style={{ display: 'flex', alignItems: 'center', height: '40px' }}>
                                        <input 
                                            type="checkbox" 
                                            checked={values.recorrente}
                                            onChange={handleChange("recorrente")}
                                            style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                        />
                                        <span style={{ marginLeft: '10px', fontSize: '14px', color: '#666' }}>Sim, repete todo ano</span>
                                    </div>
                                </div>
                            </div>

                            <div className="feriado-modal-footer">
                                <button type="button" className="btn-delete-ghost" onClick={askIfDelete}>
                                    <BsTrash /> Excluir
                                </button>
                                <button type="submit" className="btn-save" disabled={!!errors.nome || !!errors.data}>Salvar alterações</button>
                            </div>
                        </form>
                    )}
                </Formik>
            ) : (
                <div className="feriado-submitting">
                    <Lottie options={{ loop: !updateSuccess, animationData: !updateSuccess && !updateError ? LOADING : updateSuccess ? SUCCESS : ERROR }} height={120} width={120} />
                    <p>{updateSuccess ? "Salvo com sucesso!" : updateError ? "Ops, algo deu errado" : "Salvando..."}</p>
                </div>
            )}
        </div>
    );
};

export default SelectedFeriado;
